
const ColumnHeader = ({ sortable, onSort, children, sortDirection }) => {
    const sortIcon = () => {
        if (sortDirection === 'asc') {
            return 'fa-chevron-down';
        }
        else if (sortDirection === 'desc') {
            return 'fa-chevron-up';
        }
        else {
            return '';
        }
    }


    return (
        <th
            className={`text-start ${sortable ? "sortable" : ""}`}
            onClick={sortable ? onSort : undefined}
            style={{ cursor: sortable ? 'pointer' : 'default' }}
        >
            {children}
            {sortable && <i className={`fa ${sortIcon()} pl-1`} aria-hidden="true"></i>}
        </th>
    )
}

export default ColumnHeader;
